import i18n from '@/plugins/i18n';

export default {
  methods: {
    getDatePickerLocale() {
      switch (i18n.locale) {
        case 'de':
          return 'de-DE';
        default:
          return 'en-ZA';
      }
    },
  },
};
